import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=abf562a0&scoped=true"
import script from "./Student.vue?vue&type=script&lang=ts"
export * from "./Student.vue?vue&type=script&lang=ts"
import style0 from "./Student.vue?vue&type=style&index=0&id=abf562a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf562a0",
  null
  
)

export default component.exports